export default function LegalLayout({ testid, eyebrow, title, updated, children }) {
  return (
    <div data-testid={testid}>
      <section className="border-b border-black/10 relative overflow-hidden">
        <div className="absolute inset-0 bg-grid opacity-60 pointer-events-none" />
        <div className="max-w-5xl mx-auto px-6 md:px-12 pt-20 pb-16 relative">
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#FF4F00] reveal-up">/ {eyebrow}</p>
          <h1 className="font-display mt-6 text-4xl sm:text-5xl md:text-6xl font-black uppercase tracking-tighter leading-[0.95] reveal-up">
            {title}
          </h1>
          <p className="mt-6 text-xs font-bold uppercase tracking-[0.25em] text-[#52525B]">Last updated: {updated}</p>
        </div>
      </section>

      <section>
        <div className="max-w-5xl mx-auto px-6 md:px-12 py-20 space-y-14">
          {children}
        </div>
      </section>
    </div>
  );
}

export function LegalSection({ title, children, testid }) {
  return (
    <div data-testid={testid}>
      <h2 className="font-display text-2xl md:text-3xl font-extrabold uppercase tracking-tight">{title}</h2>
      <div className="mt-4 text-[#52525B] leading-relaxed space-y-4 [&_a]:text-[#FF4F00] [&_a]:font-bold [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-2">
        {children}
      </div>
    </div>
  );
}
